<div class="content-dialog">
  <div class="dialog-icon">
    <mat-icon>warning_amber</mat-icon>
  </div>

  <div class="dialog-body">
    <h2 class="dialog-title">
      {{ data?.message || 'Sin data' }}
    </h2>

    <p class="dialog-question" *ngIf="data?.question">
      {{ data?.question || 'Sin data' }}
    </p>
  </div>

  <div
    class="actions-dialog"
    [class.single-action]="
      (btnCancel === true && btnConfirm !== true) ||
      (btnConfirm === true && btnCancel !== true)
    "
  >
    <button
      *ngIf="btnCancel === true"
      mat-stroked-button
      class="btn-cancelar"
      [mat-dialog-close]="data"
      (click)="onNoClick()"
    >
      {{ data?.textBtnCancel || 'CANCELAR' }}
    </button>

    <button
      *ngIf="btnConfirm === true"
      mat-flat-button
      class="btn-generar"
      [mat-dialog-close]="data"
      (click)="data.confirm = true"
    >
      {{ data?.textBtnConfirm || 'CONFIRMAR' }}
    </button>
  </div>
</div>
